import '../Styles/specialLotteryInterferer.scss';

window.am = window.am || {};

window.am.specialLotteryInterferer = new function() {
    var that = this;
    const localStorageItemName = 'special-lottery-interferer-state';

    that.init = function() {
        that.setEvents();
        that.show();

        var isExperienceEditor = document.querySelector(".special-lottery-interferer-opener.sc-exp");

        if (isExperienceEditor) {
            that.close();
        }
    };

    that.open = function() {
        var openers = document.querySelectorAll('.special-lottery-interferer-opener');
        var windows = document.querySelectorAll('.special-lottery-interferer-window');
        var windowBox = document.querySelector('.special-lottery-interferer-window-box');
        var windowBubble = document.querySelector('.special-lottery-interferer-window-bubble');

        openers.forEach(function(opener) {
            opener.classList.add('special-lottery-interferer-opener--opened');
        });

        windows.forEach(function (window) {
            window.classList.add('special-lottery-interferer-window--opened');
        });

        if (windowBox.offsetHeight > 0 && windowBubble) {
            windowBubble.style.bottom = windowBox.offsetHeight/16 - 1.375 + 'rem';
        }

        sessionStorage.setItem(localStorageItemName, 'open')
    };

    that.close = function () {
        var openers = document.querySelectorAll('.special-lottery-interferer-opener');
        var windows = document.querySelectorAll('.special-lottery-interferer-window');

        openers.forEach(function (opener) {
            opener.classList.remove('special-lottery-interferer-opener--opened');
        });

        windows.forEach(function (window) {
            window.classList.remove('special-lottery-interferer-window--opened');
        });
                
        sessionStorage.setItem(localStorageItemName, 'close')
    };

    that.windowBoxesClick = function (e) {
        document.querySelector('.special-lottery-interferer-window-box-link a').click();
    };

    that.trackClick = function () {
        var eventId = this.dataset.eventId;

        if (utag != undefined) {
            utag.link({
                'etracker_event_action': 'click',
                'event_id': eventId
            });
        }
    };

    that.setBubblePosition = () => {
        var windowBoxContainerDesktop = document.querySelector('.special-lottery-interferer-window.special-lottery-interferer-desktop');
        if (!windowBoxContainerDesktop) {
            return;
        }
        var windowBox = windowBoxContainerDesktop.querySelector('.special-lottery-interferer-window-box');
        var windowBubble = windowBoxContainerDesktop.querySelector('.special-lottery-interferer-window-bubble');
        if (windowBubble && windowBox && windowBox.offsetHeight > 0) {
            windowBubble.style.bottom = windowBox.offsetHeight/16 - 1.375 + 'rem';
        }
    }

    that.show = () => {
        if (window.innerWidth >= 768) {
            if (document.querySelector('.special-lottery-interferer-desktop') == null) {
                let temp = document.querySelector(".special-lottery-interferer-desktop-template");
                let clon = temp.content.cloneNode(true);
                document.body.appendChild(clon);
                that.setEvents();
            }
        } else {
            if (document.querySelector('.special-lottery-interferer-mobile') == null) {
                let temp = document.querySelector(".special-lottery-interferer-mobile-template");
                let clon = temp.content.cloneNode(true);
                document.body.appendChild(clon);
                that.setEvents();
            }
        }

        that.setBubblePosition();

        if (sessionStorage.getItem(localStorageItemName) == 'close') {
            that.close();
        }
    };

    that.setEvents = () => {
        var openers = document.querySelectorAll('.special-lottery-interferer-opener');
        var closes = document.querySelectorAll('.special-lottery-interferer-window-close');
        var ctas = document.querySelectorAll('.special-lottery-interferer-window-box-link a');
        var windowBoxes = document.querySelectorAll('.special-lottery-interferer-mobile .special-lottery-interferer-window-box');
        
        openers.forEach(function (opener) {
            opener.addEventListener('click', that.open);
        });

        closes.forEach(function (close) {
            close.addEventListener('click', that.close);
        });

        ctas.forEach(function (cta) {
            cta.addEventListener('click', that.trackClick);
        });

        windowBoxes.forEach(function (windowBox) {
            windowBox.addEventListener('click', that.windowBoxesClick);
        });

        window.addEventListener("resize", that.show);
        window.addEventListener("orientationchange", that.show);
    };
};

window.am.specialLotteryInterferer.init();